@if (!!message) {
<div class="wrapper" [ngClass]="{ hidden: !showModal }">
  <mat-card>
    <mat-card-content>
      <mat-icon class="icon" [ngClass]="messageType">{{
        messageType === 'error'
          ? 'error_outline'
          : messageType === 'warning'
          ? 'warning_amber'
          : 'check_circle'
      }}</mat-icon>
      <h6>{{ message.title }}</h6>
      <p [innerHTML]="message.text"></p>
    </mat-card-content>
    @if (message.buttons) {
    <mat-card-actions>
      @for (button of message.buttons; track button) { @if (button.type ===
      'cancel') {
      <button
        mat-stroked-button
        class="submit-button"
        type="submit"
        [ngClass]="{ 'full-width': message.buttons.length === 1 }"
        (click)="onButtonClick(button)"
      >
        {{ button.label }}
      </button>
      } @if (button.type === 'confirm') {
      <button
        mat-flat-button
        class="submit-button"
        color="primary"
        type="submit"
        [ngClass]="{ 'full-width': message.buttons.length === 1 }"
        (click)="onButtonClick(button)"
      >
        {{ button.label }}
      </button>
      } }
    </mat-card-actions>
    }
  </mat-card>
</div>
}
